<div class="notification-demo-container">
  <h2>Demonstração de Notificações</h2>
  
  <div class="notification-section">
    <h3>Notificações de Sucesso</h3>
    <div class="buttons-group">
      <button mat-raised-button color="primary" (click)="showSuccessNotification()">
        <mat-icon>check_circle</mat-icon>
        Sucesso Simples
      </button>
      <button mat-raised-button color="primary" (click)="showSuccessHtmlNotification()">
        <mat-icon>code</mat-icon>
        Sucesso com HTML
      </button>
    </div>
  </div>
  
  <div class="notification-section">
    <h3>Notificações de Erro</h3>
    <div class="buttons-group">
      <button mat-raised-button color="warn" (click)="showErrorNotification()">
        <mat-icon>error</mat-icon>
        Erro
      </button>
    </div>
  </div>
  
  <div class="notification-section">
    <h3>Notificações de Alerta</h3>
    <div class="buttons-group">
      <button mat-raised-button style="background-color: #FFC107; color: black" (click)="showWarnNotification()">
        <mat-icon>warning</mat-icon>
        Alerta Simples
      </button>
      <button mat-raised-button style="background-color: #FFC107; color: black" (click)="showWarnWithAction()">
        <mat-icon>warning</mat-icon>
        Alerta com Ação
      </button>
    </div>
  </div>
  
  <div class="notification-section">
    <h3>Modais</h3>
    <div class="buttons-group">
      <button mat-raised-button style="background-color: #FF9800; color: white" (click)="showPermissionNotification()">
        <mat-icon>lock</mat-icon>
        Permissão Negada
      </button>
      <button mat-raised-button style="background-color: #9E9E9E; color: white" (click)="showInternalErrorNotification()">
        <mat-icon>build</mat-icon>
        Erro Interno Padrão
      </button>
      <button mat-raised-button style="background-color: #9E9E9E; color: white" (click)="showCustomInternalError()">
        <mat-icon>build</mat-icon>
        Erro Interno Personalizado
      </button>
    </div>
  </div>
  
  <div class="notification-section">
    <h3>Notificação de Progresso</h3>
    <div class="buttons-group">
      <button mat-raised-button color="primary" (click)="showProgressNotification()">
        <mat-icon>hourglass_empty</mat-icon>
        {{ progressActive ? 'Parar Progresso' : 'Iniciar Progresso' }}
      </button>
    </div>
    <mat-progress-bar *ngIf="progressActive" mode="determinate" [value]="progressValue" style="margin-top: 10px;"></mat-progress-bar>
  </div>
</div> 